import v from 'voca';

export function parseBoolean(str) {
  return str === 'true' || str === true || str === 1;
}

export function parseToFloat(str) {
  return v.isBlank(str) ? null : parseFloat(str);
}

export function parseToInt(str) {
  return v.isBlank(str) ? null : parseInt(str, 10);
}
